export var PRODUCTION_BASE_URL = 'https://web5.zuppler.com';
export var TESTING_BASE_URL = 'https://order.biznettechnologies.com';